import { format, subDays, subMonths } from "date-fns";

export function formatMoney(value: number | null | undefined): string {
  if (value === null || value === undefined) {
    return "0";
  }

  const numValue = Number(value);
  if (isNaN(numValue)) {
    return "0";
  }

  return numValue.toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}

/**
 * Formats the current date (minus `subDays`) into a given format.
 *
 * @param {string} [formatStr="dd MMMM yyyy"] - Desired output format (e.g., "MM/dd/yyyy").
 * @param {number} [daysToSubtract=0] - Days to subtract from today. Defaults to 0 (today).
 * @returns {string} Formatted date string.
 */
export function formatRelativeDate(
  formatStr: string = "dd MMMM yyyy",
  daysToSubtract: number = 0
): string {
  const date = subDays(new Date(), daysToSubtract);
  return format(date, formatStr);
}

/**
 * Returns the full month name (e.g., "January") for a date relative to today.
 *
 * @param {number} [subMonths=0] - Months to subtract from today. Defaults to 0 (current month).
 * @returns {string} Full month name.
 */
export function getMonthName(offset: number = 0): string {
  const date = subMonths(new Date(), offset);
  return format(date, "MMMM");
}

// Order status
export const renderOrderStatus = (order_status: number): string => {
  if (order_status === 0) return "New";
  else if (order_status === 1) return "Out For Delivery";
  else if (order_status === 2) return "Delivered";
  else if (order_status === 3) return "Cancelled";
  else if (order_status === 4) return "Assigned";
  else if (order_status === 5) return "Pick Pack";
  else if (order_status === 6) return "Invoiced";
  else if (order_status === 7) return "Closed";
  else if (order_status === 8) return "Partially Delivered";
  else if (order_status === 9) return "Returned";
  return "";
};

// Delivery type
export const renderOrderDeliveryType = (
  order_delivery_type: number
): string => {
  if (order_delivery_type === 1) return "STANDARD";
  else if (order_delivery_type === 2) return "QUICK_DELIVERY";
  else if (order_delivery_type === 3) return "SCHEDULED";
  return "";
};
